import router from 'next/router'
import { useEffect } from 'react'
import { useCustomer } from '../../hooks/customer/useCustomer'
import { useCustomerNewsletter } from '../../hooks/customer/useCustomerNewsletter'
import { useTrackingsActions } from '../../hooks/trackings'
import { useUser } from '../../providers/user'

const TrackingsGlobal = () => {
	const [{ isLoggedIn }] = useUser()

	const { pageView, userState, hashChange, customerInfo } = useTrackingsActions()

	const { loading: loadingCustomer, ...customer } = useCustomer()

	const { subscribed, loading: loadingNewsletter } = useCustomerNewsletter()

	useEffect(() => {
		const {
			location: { pathname, search, hash },
		} = window

		const url = `${pathname}${search}${hash}`

		const handlePageView = (url, options, previousAs) => {
			const { pathname, search, hash } = new URL(`${location.origin}${url}`)

			pageView({
				path: `${pathname}${search}${hash}`,
				oldHistoryUrl: previousAs ? location.origin + previousAs : '',
				newHistoryUrl: location.href,
			})
		}

		handlePageView(url)

		router.events.on('bh_afterHistoryChange', handlePageView)

		const handleHashChange = (url) => {
			const { hash } = new URL(`${location.origin}${url}`)
			hashChange({ hash })
		}

		handleHashChange(url)

		router.events.on('hashChangeStart', handleHashChange)

		return () => {
			router.events.off('bh_afterHistoryChange', handlePageView)
			router.events.off('hashChangeStart', handleHashChange)
		}
	}, [pageView, hashChange])

	useEffect(() => {
		userState({ isLoggedIn })
	}, [isLoggedIn, userState])

	useEffect(() => {
		if (isLoggedIn && !loadingCustomer && !loadingNewsletter && customer.id && subscribed !== undefined) {
			customerInfo({ customer, subscribed })
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoggedIn, customer.email, subscribed, customerInfo])

	return null
}

export default TrackingsGlobal
